import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Components
import ScrollToTop from './components/ScrollToTop';
import Topbar from './components/Topbar';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingWidgets from './components/FloatingWidgets';

// Pages
import Home from './pages/Home';
import PageDetail from './pages/PageDetail';
import NewsIndex from './pages/NewsIndex';
import NewsDetail from './pages/NewsDetail';

function App() {
  return (
    <>
      <ScrollToTop />
      <FloatingWidgets />
      <div className="min-h-screen flex flex-col bg-slate-950 text-slate-300 antialiased">
        {/* Topbar */}
        <Topbar />

        {/* Header/Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            {/* Home Route */}
            <Route path="/" element={<Home />} />

            {/* News/Oplæg Routes */}
            <Route path="/nyheder" element={<NewsIndex />} />
            <Route path="/nyheder/:slug" element={<NewsDetail />} />

            {/* Dynamic Page Routes (Værkstedet, Montage, Vandskæring, Om os, Referencer, Kontakt, English) */}
            <Route path="/:slug" element={<PageDetail />} />

            {/* Fallback to Home */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
